import React from 'react'
import { SanityTwoColumnText } from '../../../../../types/generated/graphql-types'
import { mapSanityTwoColumnTextToTwoColumnTextProps } from '../../../../mapping/TwoColumnTextMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { IS_EQT_FUNDS, IS_EQT_MARKET } from '../../../../utilities/site'
import { TwoColumnText } from '../../../blocks/TwoColumnText'
import { MarketSection } from '../../../MarketSection'
import { Section } from '../../../Section'

export const TwoColumnTextSerializer = ({
  id,
  ...props
}: SanityTwoColumnText & BlockWithId) =>
  IS_EQT_MARKET || IS_EQT_FUNDS ? (
    <MarketSection applyGrid={false} id={id}>
      <TwoColumnText {...mapSanityTwoColumnTextToTwoColumnTextProps(props)} />
    </MarketSection>
  ) : (
    <Section id={id}>
      <TwoColumnText {...mapSanityTwoColumnTextToTwoColumnTextProps(props)} />
    </Section>
  )
